import { Link, useNavigate } from 'react-router-dom';
import { User } from 'lucide-react';
import { Button } from '@kss/ui';
import { useAuth, isPanelRole } from '@kss/auth';

export function WebHeader() {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuth();
  const canSeePanel = isAuthenticated && isPanelRole(user?.role);

  return (
    <header className="sticky top-0 z-30 w-full border-b border-border bg-surface-card/95 backdrop-blur">
      <div className="mx-auto flex h-14 max-w-7xl items-center justify-between gap-4 px-4">
        <Link to="/" className="flex items-center gap-2 font-semibold text-content-primary">
          <span className="inline-flex h-7 w-7 items-center justify-center rounded bg-primary text-white">K</span>
          <span>KSS BillBook</span>
        </Link>
        <nav className="hidden items-center gap-6 text-sm text-content-secondary md:flex">
          <Link to="/" className="hover:text-content-primary">Home</Link>
          <Link to="/about" className="hover:text-content-primary">About</Link>
          <Link to="/contact" className="hover:text-content-primary">Contact</Link>
        </nav>
        <div className="flex items-center gap-2">
          {canSeePanel && (
            <Button size="sm" onClick={() => navigate('/panel/dashboard')}>
              Open panel
            </Button>
          )}
          {!isAuthenticated && (
            <Button size="sm" variant="outline" onClick={() => navigate('/login')}>
              <User className="h-3.5 w-3.5" /> Sign in
            </Button>
          )}
        </div>
      </div>
    </header>
  );
}

export default WebHeader;
